import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

// Operator page header — the foundation replacement for the marketing `PageHero` idiom.
// Title + a FACTUAL one-liner + right-aligned actions. No eyebrow, no pitch subtitle, no
// hero background. Title carries hierarchy through weight + tight tracking (Apple type
// contract), never a display/serif face. See docs/plans/console-screen-pattern.md.
//
// `title` is optional ON PURPOSE: the shell's site header already names every routed screen
// from the nav registry, so a page repeating that name renders the same words twice within
// a hundred pixels. A screen whose name the shell carries opens with just the factual line
// (+ actions, + an optional `identity` chip for record routes); only screens the shell
// cannot name pass a `title`.
export function PageHeader({
  title,
  identity,
  description,
  actions,
  className,
}: {
  title?: string
  /** Record identity for detail/edit routes — a mono id + status chip row, not a heading. */
  identity?: ReactNode
  description?: string
  actions?: ReactNode
  className?: string
}) {
  return (
    <div className={cn("flex flex-wrap items-start justify-between gap-4", className)}>
      <div className="min-w-0">
        {title ? <h1 className="text-[1.75rem] font-semibold leading-tight tracking-[-0.02em]">{title}</h1> : null}
        {identity ? <div className={cn("flex flex-wrap items-center gap-2", title && "mt-1")}>{identity}</div> : null}
        {description ? (
          <p className={cn("max-w-3xl text-sm leading-relaxed text-muted-foreground", (title || identity) && "mt-1.5")}>
            {description}
          </p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2.5">{actions}</div> : null}
    </div>
  )
}
